<template>
  <div>
    <div class="Breadcrumb">
      <el-breadcrumb>
        <!-- 费用管理 -->
        <el-breadcrumb-item>
          {{ $t("message.costManagement") }}</el-breadcrumb-item>
        <!-- 长存仓储费 -->
        <el-breadcrumb-item>{{
          $t("message.longTermStorageFeeConfiguration")
        }}</el-breadcrumb-item>
        <!-- 新增配置 -->
        <el-breadcrumb-item>{{
          $t("message.addConfiguration")
        }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="body">
      <div class="form">
        <!--生效日期  -->
        <div class="row">
          <div class="label">{{ $t("message.effectiveDate") }}</div>
          <div class="value">
            <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              :start-placeholder="$t('message.startDate')" :end-placeholder="$t('message.endTime')" />
          </div>
        </div>
        <!-- 计价类型 -->
        <div class="row">
          <div class="label">{{ $t("message.valuationType") }}</div>
          <div class="value" style="font-size: 18px;">{{ $t("message.threeSidesSum") }}</div>
        </div>
        <!-- 计算区间 -->
        <div class="row">
          <div class="label">{{ $t("message.calculationInterval") }}</div>
          <div class="value">
            <div class="template">
              <!-- 增加计价区间 -->
              <div class="add-item">
                <el-button type="success" @click="addValuationInterval">{{ $t('message.addValuationInterval')
                }}</el-button>
                <!-- 注意事项：区间表示大于左边，小于等于右边，结束值不填默认为上限无穷大。 -->
                <div class="tip">{{ $t('message.addValuationIntervalTip') }}</div>
              </div>
              <!-- 计价区间 -->
              <div class="item" v-for="(item, index) in form.config_data" :key="index">
                <div class="item-head">
                  <!-- 客户等级： -->
                  <div class="left">{{ $t("message.customerLevel") }}:
                    <el-select v-model="item.client_level_ids" placeholder="请选择" multiple
                      @change="handleClientLevelChange(item, $event)">
                      <el-option v-for="item in clientLevels" :key="item.id" :label="item.level_name"
                        :value="item.id"></el-option>
                    </el-select>
                  </div>
                  <el-button type="primary" @click="deleteValuationInterval(index)">{{ $t('message.delete')
                  }}</el-button>
                </div>
                <div class="table">
                  <ol>
                    <li>
                      NO
                    </li>
                    <!-- 三边和 -->
                    <li class="flex5">{{ $t("message.threeSidesSum") }}</li>
                    <!-- 价格（円） -->
                    <li>{{ $t("message.priceInYen") }}</li>
                    <!-- 价格类别 -->
                    <li>{{ $t("message.priceCategory") }}</li>
                    <!-- 操作 -->
                    <li>{{ $t("message.operation") }}</li>
                  </ol>
                  <ul v-for="(range, rangeIndex) in item.ranges" :key="rangeIndex">
                    <li>
                      {{ rangeIndex + 1 }}
                    </li>
                    <!-- 三边和 -->
                    <li class="flex5">
                      <div class="template">
                        <div class="flex05">
                          <el-input v-model="range.range_start" placeholder="区间开始值"
                            @input="handleNum(index, rangeIndex, 'range_start')"
                            @blur="minMaxCheck(index, rangeIndex, 'range_start')"></el-input>
                        </div>
                        <div class="flex05">
                          <el-input v-model="range.range_end" placeholder="区间结束值"
                            @input="handleNum(index, rangeIndex, 'range_end')"
                            @blur="minMaxCheck(index, rangeIndex, 'range_end')"></el-input>
                        </div>
                      </div>
                    </li>
                    <!-- 价格（円） -->
                    <li>
                      <el-input v-model="range.price" placeholder="请输入价格"
                        @input="handleNum(index, rangeIndex, 'price')"></el-input>
                    </li>
                    <!-- 价格类别 -->
                    <li>固定价</li>
                    <!-- 操作 -->
                    <li>
                      <el-button type="text" @click="deleteRange(index, rangeIndex)">{{ $t('message.delete')
                      }}</el-button>
                    </li>
                  </ul>
                </div>
                <div class="btn">
                  <!-- 新增一行 -->
                  <el-button type="success" @click="addRange(index)">+{{ $t('message.addRow') }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 提交 -->
      <div class="submit">
        <!-- 取消 -->
        <el-button @click="$parent.isAddBilling = false">{{ $t('message.cancel') }}</el-button>
        <!-- 确认提交 -->
        <el-button type="primary" @click="submit" v-if="isAdd">{{ $t('message.confirmSubmit') }}</el-button>
        <!-- 更新 -->
        <el-button type="primary" @click="storageFeeConfigUpdate" v-else>{{ $t('message.updateConfiguration')
        }}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAdd: true,
      time: [],
      form: {
        customerLevel: '',
        start_date: '',
        end_date: '',
        fee_type: 'three_side_sum',
        status: 0,
        config_data: [
          {
            client_level: '',
            client_level_ids: [],
            ranges: [
              {
                range_start: '',
                range_end: '',
                price: 0,
              }
            ],

          }
        ]
      },
      clientLevels: [],
    }
  },
  created() {
    this.getClientLevels();
  },
  methods: {
    // 长存仓储费-获取客户等级列表
    getClientLevels() {
      this.$api.costManagementApi.getClientLevels().then(res => {
        this.clientLevels = res.data
      })
    },
    handleClientLevelChange(item, selectedIds) {
      if (!selectedIds.some(id => id == 'all')) {
        return;
      }

      let lastSelectedId = selectedIds[selectedIds.length - 1];
      item.client_level_ids = lastSelectedId == 'all'
        ? ['all']
        : selectedIds.filter(id => id != 'all');
    },
    // 长存仓储费-新增计价区间
    addValuationInterval() {
      this.form.config_data.push({
        client_level: '',
        client_level_ids: [],
        ranges: [
          {
            range_start: '',
            range_end: '',
            price: 0,
          }
        ],

      })
    },
    // 长存仓储费-删除计价区间
    deleteValuationInterval(index) {
      this.form.config_data.splice(index, 1);
      this.$forceUpdate();
    },
    // 长存仓储费-新增计价区间-新增一行
    addRange(index) {
      this.form.config_data[index].ranges.push({
        range_start: '',
        range_end: '',
        price: 0,
      })
    },
    // 长存仓储费-新增计价区间-删除一行
    deleteRange(index, rangeIndex) {
      this.form.config_data[index].ranges.splice(rangeIndex, 1);
      this.$forceUpdate();
    },
    // 长存仓储费-新增计价区间-提交
    submit() {
      // 校验客户等级
      if (this.form.config_data.some(item => !item.client_level_ids.length)) {
        this.$message({
          message: this.$t('message.pleaseSelectClientLevel'),
          type: 'error',
        })
        return;
      }
      // 校验价格区间
      if (this.form.config_data.some(item => item.ranges.some(range => range.range_start === '' || !range.price))) {
        this.$message({
          message: this.$t('message.pleaseFillPriceRange'),
          type: 'error',
        })
        return;
      }
      if (this.time.length == 0) {
        this.$message({
          message: this.$t('message.pleaseSelectTime'),
          type: 'error',
        })
        return;
      } else {
        this.form.start_date = this.time[0];
        this.form.end_date = this.time[1];
      }
      this.form.config_data.forEach(item => {
        let isAll = item.client_level_ids.some(id => id == 'all')
        if (isAll) {
          item.client_level = 'all'
        } else {
          item.client_level = 'specific'
        }
      })
      // 新增配置     c
      this.$confirm(this.$t('message.confirmAddConfiguration'), this.$t('message.ddConfiguration'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.costManagementApi.storageFeeConfigStore(this.form).then(res => {
          this.$message.success(res.msg);
          this.$parent.storageFeeConfigList();
          this.$parent.isAddBilling = false;
        })
      }).catch(() => {
      });
    },
    // 长存仓储费-更新
    storageFeeConfigUpdate() {
      // 校验客户等级
      if (this.form.config_data.some(item => !item.client_level_ids.length)) {
        this.$message({
          message: this.$t('message.pleaseSelectClientLevel'),
          type: 'error',
        })
        return;
      }
      // 校验价格区间
      if (this.form.config_data.some(item => item.ranges.some(range => range.range_start === '' || !range.price))) {


        this.$message({
          message: this.$t('message.pleaseFillPriceRange'),
          type: 'error',
        })
        return;
      }
      if (this.time.length == 0) {
        this.$message({
          message: this.$t('message.pleaseSelectTime'),
          type: 'error',
        })
        return;
      } else {
        this.form.start_date = this.time[0];
        this.form.end_date = this.time[1];
      }
      this.form.config_data.forEach(item => {
        let isAll = item.client_level_ids.some(id => id == 'all')
        if (isAll) {
          item.client_level = 'all'
        } else {
          item.client_level = 'specific'
        }
      })
      this.$confirm(this.$t('message.confirmUpdateConfiguration'), this.$t('message.updateConfiguration'), {
        confirmButtonText: this.$t('message.confirm'),
        cancelButtonText: this.$t('message.cancel'),
        type: 'warning',
        center: true,
      }).then(() => {
        this.$api.costManagementApi.storageFeeConfigUpdate(this.form).then(res => {
          this.$message.success(res.msg);
          this.$parent.storageFeeConfigList();
          this.$parent.isAddBilling = false;
        })
      }).catch(() => {

      });
    },
    // 长存仓储费-只能输入数字并且只能有一个小数
    handleNum(index, rangeIndex, type) {
      let range = this.form.config_data[index].ranges[rangeIndex];
      range[type] = ("" + range[type])
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,1})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，
    },
    // 校验区间开始值和结束值是否大于0
    minMaxCheck(index, rangeIndex, type) {

      let range = this.form.config_data[index].ranges[rangeIndex];
      if (range[type] === '') {
        return;
      }

      let maxRangeEnd = rangeIndex > 0 ? Number(this.form.config_data[index].ranges[rangeIndex - 1].range_end) : 0
      let rangeStart = Number(range.range_start)
      let rangeEnd = Number(range.range_end)
      // 校验区间开始值是否小于区间结束值
      if (type == 'range_start' && rangeIndex > 0 && rangeStart < maxRangeEnd) {
        range.range_start = maxRangeEnd
        this.$message({
          message: this.$t('message.rangeStartMustGreaterThanEnd'),
          type: 'error',
        })

      } else if (type == 'range_end' && rangeEnd < rangeStart) {
        range.range_end = range.range_start
        this.$message({
          message: this.$t('message.rangeEndMustGreaterThanStart'),
          type: 'error',
        })
      }
      this.$forceUpdate()
    }
  }
}
</script>
<style scoped lang="scss">
.Breadcrumb {
  margin-bottom: 20px;
  padding: 18px 20px;
  background-color: #F8F8F8;

}

.form {
  width: 1250px;
  border: 1px solid #DCDFE6;

  .row {
    border-bottom: 1px solid #DCDFE6;
    display: flex;

    &:last-child {
      border-bottom: none;
    }

    .label {
      width: 300px;
      padding: 30px 42px;
      border-right: 1px solid #DCDFE6;
      font-size: 14px;
      background-color: #EDEFF4;
      color: #333333;
      font-size: 18px;
      display: flex;
      align-items: center;

    }

    .value {
      flex: 1;
      padding: 30px 42px;

      color: #333333;
      display: flex;
      align-items: center;
      background-color: #fff;

      .template {
        width: 100%;
      }

      .add-item {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin-bottom: 12px;

        .tip {
          margin-top: 10px;
          height: 18px;
          border-radius: 4px;
          font-size: 14px;
          color: #909399;
          padding: 6px;
          background: #FAF2F2;
          color: #B4272D;
        }


      }

      .item {
        padding: 24px;
        border: 1px solid #DCDFE6;
        border-radius: 10px;
        margin-bottom: 24px;

        &:last-child {
          margin-bottom: 0;
        }

        .item-head {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 12px;
        }

        .table {
          ol {
            height: 44px;
          }

          ul {
            padding: 24px 0;
          }

          li {
            margin-right: 12px;

            &:last-child {
              margin-right: 0;
            }
          }

          .flex5 {
            flex: 5;

            .template {
              display: flex;
              justify-content: space-between;

              .flex05 {
                width: 180px;
              }
            }
          }

        }

        .btn {
          margin-top: 12px;
        }
      }
    }
  }
}

.submit {
  margin-top: 20px;
  text-align: center;
}
</style>
